import { type ReactNode, useEffect, useRef } from 'react';
import { Typography } from '@mui/material';

const APP_TITLE = 'Zugang aktivieren';

/**
 * Page/step heading that receives focus when it mounts (§82): screen readers announce the new
 * step and keyboard users continue from the top of the content. Key it by step to re-focus.
 * String headings also set the document title (React 19 hoists `<title>`).
 */
export function PageHeading({ children }: { children: ReactNode }) {
  const ref = useRef<HTMLHeadingElement>(null);
  useEffect(() => {
    ref.current?.focus();
  }, []);
  return (
    <>
      {typeof children === 'string' ? (
        <title>{children === APP_TITLE ? APP_TITLE : `${children} – ${APP_TITLE}`}</title>
      ) : null}
      <Typography
        ref={ref}
        variant="h1"
        component="h1"
        tabIndex={-1}
        // Not interactive (tabIndex -1): focus only moves the reading position, no focus ring.
        sx={{ mb: 2, '&:focus': { outline: 'none' } }}
      >
        {children}
      </Typography>
    </>
  );
}
